(() => {
    let tabsHeaderBrandTabsMobile = document.getElementsByClassName('header__brands-tab--mobile');
    let tabsContainer = document.getElementsByClassName('tabs-container-desk');
    let tabs = tabsContainer[0].getElementsByClassName('tab-item');

    tabsHeaderBrandTabsMobile[0].style.setProperty('--tabs-overflow', 'hidden');

    var window_width = null;
    let location = window.location.href;
    var imageContainer = '';

    const actualLocation = window.location.href;
    const dataBodyAttribute = document.getElementsByTagName('body')[0].dataset.brand;

    widthActual();

    // Calcula el ancho del viewport
    function widthActual() {
        return window_width = window.innerWidth;
    }

    // Valida la vista y determina el contenedor picture a usar con la imagen poner como fondo en el navbar (MOB & DESK)
    function setBgHeaderWrapper() {
        // Crear un canvas
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        // Crear una nueva imagen
        let img = new Image();
        img.crossOrigin = "anonymous"; // Asegurar que la imagen sea accesible

        let imageUrl = '';
        let imageUrlFinal = '';
        let str = '';
        let actualLocation = window.location.href;

        if ((!location.includes('decor') && (dataBodyAttribute == 'general' || dataBodyAttribute == 'index')) || (dataBodyAttribute != '' && dataBodyAttribute == 'acento')) {
            // Determinar el contenedor de la imagen según el ancho de la ventana
            if (window_width <= 699) {
                imageContainer = document.querySelector('.image-mob-secondary__image--mobile-1');

            } else if (window_width >= 700 && window_width < 1150) {
                imageContainer = document.querySelector('.image-desk-secondary__image--desktop-1');

            } else if (window_width >= 1150) {
                imageContainer = document.querySelector('.image-desk-secondary__image--desktop-1');

            }

            imageUrl = imageContainer.getElementsByTagName('img')[0].currentSrc;

            str = imageUrl.indexOf('&');
            imageUrlFinal = imageUrl.substring(0, str);

            img.src = imageUrlFinal;
        } else {
            if (window_width <= 699) {
                imageContainer = document.querySelector('.image-mob-secondary__image--mobile-2');

            } else if (window_width >= 700 && window_width < 1150) {
                imageContainer = document.querySelector('.image-desk-secondary__image--desktop-2');

            } else if (window_width >= 1150) {
                imageContainer = document.querySelector('.image-desk-secondary__image--desktop-2');
            }


            if ((actualLocation.includes('decor') && dataBodyAttribute == 'decor-living') || (dataBodyAttribute != '' && dataBodyAttribute == 'decor-living') || (!actualLocation.includes('decor') && dataBodyAttribute != '' && dataBodyAttribute == 'decor-living')) {
                if (window_width <= 699) {
                    imageContainer = document.querySelector('.image-mob-secondary__image--mobile-2');

                } else if (window_width >= 700 && window_width < 1150) {
                    imageContainer = document.querySelector('.image-desk-secondary__image--desktop-2');

                } else if (window_width >= 1150) {
                    imageContainer = document.querySelector('.image-desk-secondary__image--desktop-2');
                }

                imageUrl = imageContainer.getElementsByTagName('img')[0].currentSrc;

                str = imageUrl.indexOf('&');
                imageUrlFinal = imageUrl.substring(0, str);

                img.src = imageUrlFinal;
            }
        }

        img.onload = function () {
            // Obtener las dimensiones originales de la imagen
            const widthOriginal = img.width;
            const heightOriginal = img.height;

            // Coordenadas y dimensiones del fragmento a recortar
            const sx = 0; // Coordenada X del punto de inicio del recorte (parte izquierda)
            const sy = 0; // Coordenada Y del punto de inicio del recorte (parte superior)
            const sWidth = widthOriginal; // Ancho del recorte (usar el ancho completo de la imagen)
            const sHeight = heightOriginal; // Alto del recorte (usar el alto completo de la imagen)

            // Configurar el tamaño del canvas
            canvas.width = widthOriginal;
            canvas.height = heightOriginal;

            // Dibujar el fragmento de la imagen en el canvas
            ctx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, sWidth, sHeight);

            // Convertir el contenido del canvas a una URL de datos
            const imageUrl = canvas.toDataURL('image/png');

            let elemento = '';

            elemento = document.querySelector('.header__wrapper--override-enchliving');

            if (elemento) {
                elemento.style.backgroundImage = `url(${imageUrl})`;
                elemento.style.backgroundSize = '100%'; // Ajustar el tamaño del fondo
                elemento.style.backgroundPosition = 'top top'; // Centrar el fondo
            } else {
                console.error('No se encontró el elemento con la clase "header__wrapper--override-enchliving');
            }
        };

        img.onerror = function () {
            console.error('Error al cargar la imagen');
        };
    }

    function moveBackgroundToTopLeft() {
        let tabsContainerMobile = document.getElementsByClassName('header__brands-tab--desk');
        let tabsMobile = tabsContainerMobile[0].getElementsByClassName('tab-item');

        let tabsContainer = document.getElementsByClassName('tabs-container-desk');
        let tabs = tabsContainer[0].getElementsByClassName('tab-item');


        // IMAGEN DESK REFERENCIA
        let imageBanner = '';
        let imageBannerType = ''

        if (document.getElementsByClassName('image-banner__image--mobile-1')[0]) {
            imageBanner = document.getElementsByClassName('image-banner__image--mobile-1')[0];
            imageBannerType = 1;
        } else {
            imageBanner = document.getElementsByClassName('header__wrapper--override-enchliving-inside')[0];
            imageBannerType = 2;
        }

        let bannerRect = imageBanner.getBoundingClientRect();

        if (window_width >= 669 && window_width < 1500) {
            // DECOR TAB ---------
            let tab2 = tabsMobile[1];

            if (!tab2) {
                console.error('No se encontró el elemento tabs[1]');
                return;
            }

            let tab2Rect = tab2.getBoundingClientRect();

            if (imageBannerType == 1) {
                tab2.style.backgroundSize = `${bannerRect.width}px ${bannerRect.height}px`;
            } else {
                tab2.style.backgroundSize = `${bannerRect.width}px auto`;
            }

            let offsetX_tab2 = tab2Rect.x * -1; // Desplazamiento horizontal
            let offsetY_tab2 = 0; // Desplazamiento vertical
            tab2.style.backgroundPosition = `${offsetX_tab2}px ${offsetY_tab2}px`;


            let tab1 = tabsMobile[0];

            if (!tab1) {
                console.error('No se encontró el elemento tabs[1]');
                return;
            }

            let tab1Rect = tab1.getBoundingClientRect();

            tab1.style.backgroundSize = `${bannerRect.width}px ${bannerRect.height}px`;
            let offsetX_tab1 = tab1Rect.x * -1; // Desplazamiento horizontal
            let offsetY_tab1 = 0; // Desplazamiento vertical
            tab1.style.backgroundPosition = `${offsetX_tab1}px ${offsetY_tab1}px`;
        }

        if (!imageBanner) {
            console.error('No se encontró el elemento <image-banner>');
            return;
        }


        // DECOR TAB ---------
        let tab2 = tabs[1];

        if (!tab2) {
            console.error('No se encontró el elemento tabs[1]');
            return;
        }

        let tab2Rect = tab2.getBoundingClientRect();

        if (imageBannerType == 1) {
            tab2.style.backgroundSize = `${bannerRect.width}px ${bannerRect.height}px`;
            tab2.style.setProperty('--tab2-size-width', `${tab2Rect.width}`);
        } else {
            tab2.style.backgroundSize = `${bannerRect.width}px auto`;
            tab2.style.setProperty('--tab2-size-width', `${tab2Rect.width}`);
        }

        // Posiciona el background en la parte superior derecha
        let offsetX_tab2 = tab2Rect.x * -1; // Desplazamiento horizontal
        let offsetY_tab2 = -bannerRect.top; // Desplazamiento vertical
        tab2.style.backgroundPosition = `${offsetX_tab2}px ${offsetY_tab2}px`;


        // Asegúrate de que el background no se repita
        tab2.style.backgroundRepeat = 'no-repeat';


        // ACENTO TAB ---------
        // Obtén el elemento tabs[1]
        let tab1 = tabs[0];
        let tab1Rect = tab1.getBoundingClientRect();

        if (!tab1) {
            console.error('No se encontró el elemento tabs[1]');
            return;
        }

        if (dataBodyAttribute == 'general' || dataBodyAttribute == 'decor-living') {
            tab1.style.backgroundSize = `${bannerRect.width}px auto`;

        } else {
            tab1.style.backgroundSize = `${bannerRect.width}px ${bannerRect.height}px`;
        }

        // Posiciona el background en la parte superior derecha
        let offsetX_tab1 = tab1Rect.x * -1; // Desplazamiento horizontal
        let offsetY_tab1 = -bannerRect.top; // Desplazamiento vertical
        tab1.style.backgroundPosition = `${offsetX_tab1}px ${offsetY_tab1}px`;

        // Asegúrate de que el background no se repita
        tab1.style.backgroundRepeat = 'no-repeat';
    }

    function moveBackgroundToTopLeftMobile() {
        let tabsContainerMobile = document.getElementsByClassName('header__brands-tab--mobile');
        let tabsMobile = tabsContainerMobile[0].getElementsByClassName('tab-item');

        let tabsContainer = tabsContainerMobile[0].getElementsByClassName('tabs-container');
        let tabs = tabsContainer[0].getElementsByClassName('tab-item');

        let tabsContainerMobile2 = document.getElementsByClassName('tabs-container-mob');
        let tabsContainerMobile2Rect = tabsContainerMobile2[0].getBoundingClientRect();

        // IMAGEN DESK REFERENCIA
        let imageBanner = '';
        let imageBannerType = ''

        if (document.getElementsByClassName('image-banner__image--mobile-1')[0]) {
            imageBanner = document.getElementsByClassName('image-banner__image--mobile-1')[0];
            imageBannerType = 1;
        } else {
            imageBanner = document.getElementsByClassName('header__wrapper--override-enchliving')[0];
            imageBannerType = 2;
        }

        let bannerRect = imageBanner.getBoundingClientRect();

        if (!imageBanner) {
            console.error('No se encontró el elemento <image-banner>');
            return;
        }


        // DECOR TAB ---------
        let tab2 = tabs[1];

        if (!tab2) {
            console.error('No se encontró el elemento tabs[1]');
            return;
        }

        let tab2Rect = tab2.getBoundingClientRect();

        if (imageBannerType == 1) {
            tab2.style.backgroundSize = `${bannerRect.width}px auto`;
        } else {
            tab2.style.backgroundSize = `${bannerRect.width}px auto`;
        }

        // Posiciona el background en la parte superior derecha
        let offsetX_tab2 = 0; // Desplazamiento horizontal
        let offsetY_tab2 = 0; // Desplazamiento vertical
        
        if (dataBodyAttribute == 'general') {
            offsetX_tab2 = tab2Rect.x * -1; // Desplazamiento horizontal
            offsetY_tab2 = (tab2Rect.bottom - tab2Rect.top) - (tab2Rect.top - tab2Rect.height); // Desplazamiento vertical
            tab2.style.backgroundPosition = `${offsetX_tab2 - 3.25}px ${offsetY_tab2 * -1}px`;
            
        } else {
            offsetX_tab2 = tab2Rect.x * -1; // Desplazamiento horizontal
            offsetY_tab2 = 15 + 3.5; // Desplazamiento vertical
            
            tab2.style.backgroundPosition = `${offsetX_tab2 - 3.25}px ${offsetY_tab2 * -1}px`;
        }


        // Asegúrate de que el background no se repita
        tab2.style.backgroundRepeat = 'no-repeat';


        // ACENTO TAB ---------
        // Obtén el elemento tabs[1]
        let tab1 = tabs[0];
        let tab1Rect = tab1.getBoundingClientRect();

        if (!tab1) {
            console.error('No se encontró el elemento tabs[1]');
            return;
        }

        if (dataBodyAttribute == 'general' || dataBodyAttribute == 'acento') {
            tab1.style.backgroundSize = `${bannerRect.width}px auto`;

        } else {
            tab1.style.backgroundSize = `${bannerRect.width}px auto`;
        }

        // Posiciona el background en la parte superior derecha
        let offsetX_tab1 = 0; // Desplazamiento horizontal
        let offsetY_tab1 = 0; // Desplazamiento vertical

        if(dataBodyAttribute == 'general') {
            offsetX_tab1 = (tab1Rect.x + 3.5) * -1; // Desplazamiento horizontal
            offsetY_tab1 = (tab1Rect.bottom - tab1Rect.top) - (tab1Rect.top - tab1Rect.height) - 5; // Desplazamiento vertical

            if (window_width < 430) {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 3.5) * -1}px ${offsetY_tab1 * -1}px`;

            } else if (window_width <= 430) {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 2.5) * -1}px ${offsetY_tab1 * -1}px`;

            } else if (window_width > 430 && window_width <= 699) {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 3.5) * -1}px ${offsetY_tab1 * -1}px`;
            } else {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 3) * -1}px ${(15 + 3.5) * -1}px`;
            }


        } else {
            offsetX_tab1 = (tab1Rect.x + 3.5) * -1; // Desplazamiento horizontal
            offsetY_tab1 = 15 + 3.5; // Desplazamiento vertical
            
            if (window_width < 430) {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 3.5) * -1}px ${offsetY_tab1 * -1}px`;
                
            } else if (window_width <= 430) {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 2.5) * -1}px ${offsetY_tab1 * -1}px`;
    
            } else if (window_width > 430 && window_width <= 699) {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 3.5) * -1}px ${offsetY_tab1 * -1}px`;
            } else {
                tab1.style.backgroundPosition = `${(tab1Rect.x + 3) * -1}px ${offsetY_tab1 * -1}px`;
            }
        }

        // Asegúrate de que el background no se repita
        tab1.style.backgroundRepeat = 'no-repeat';
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        moveBackgroundToTopLeftMobile();
        setBgHeaderWrapper();

        if (window.screenY == 0) {
            moveBackgroundToTopLeft();
            moveBackgroundToTopLeftMobile();
        }
    });

    moveBackgroundToTopLeftMobile()
    moveBackgroundToTopLeft();
    setBgHeaderWrapper();


    window.addEventListener("resize", (event) => {
        widthActual();
        setBgHeaderWrapper();
        moveBackgroundToTopLeft();
        moveBackgroundToTopLeftMobile();
    });
})()